import { LocateableStop } from "~/api/resources/Itineraries";
import { Listing } from "~/api/resources/Listings";
import { getMarkerIcon, getPositionFromLonLat } from "../helpers";
import { MarkerF, MarkerProps, useGoogleMap } from "@react-google-maps/api";
import { useEffect, useRef } from "react";
import { usePanCamera } from "../hooks";

type Props = Partial<MarkerProps> & {
  record: LocateableStop | Listing;
  focused?: boolean;
};

export const StopMarker = ({ record, focused, ...props }: Props) => {
  const ref = useRef<google.maps.Marker>();
  const { lonlat, id } = record;
  const map = useGoogleMap();
  const position = lonlat ? getPositionFromLonLat(lonlat) : null;
  const panCamera = usePanCamera(map);

  useEffect(() => {
    const marker = ref.current;
    let timeout: NodeJS.Timeout;
    if (marker) {
      marker.setAnimation(focused ? google.maps.Animation.BOUNCE : null);
      timeout = setTimeout(() => marker.setAnimation(null), 2000);
      marker.setIcon(getMarkerIcon(focused));
      if (focused) {
        const position = marker.getPosition();
        if (position) panCamera({ endPosition: position });
      }
    }
    return () => clearTimeout(timeout);
  }, [focused, panCamera]);

  if (!position) return null;

  return (
    <MarkerF
      key={id}
      icon={getMarkerIcon(focused)}
      position={position}
      onLoad={(marker) => (ref.current = marker)}
      {...props}
    />
  );
};
